import { Dispatch, SetStateAction } from "react";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { State } from "../hooks/useAsyncLoader";

export function buildDismissErrors(
  loading: State,
  setLoading: Dispatch<SetStateAction<State>>,
  key: DataTestids
) {
  return function dismissErrors() {
    if (loading.tag === "errors") {
      setLoading({ tag: "errors-dismissed", errors: loading.errors, key });
      return "state-set";
    } else {
      return "no-op";
    }
  };
}
